import { ChangeEvent, FC, useState, useEffect } from 'react';
import { Table } from '@tanstack/react-table';
import { Flex, Text, Select, IconButton } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useTranslation } from 'helpers/languages/translations';
import { paginationContainerStyle } from '../styles';

const TablePagination: FC<{ table: Table<any>; pageSize?: number }> = ({ table, pageSize }) => {
    const translate = useTranslation();
    const [currentPageSize, setCurrentPageSize] = useState('15');

    useEffect(() => {
        if (!pageSize) table.setPageSize(15);
    }, []);

    const handleChangeSelect = (event: ChangeEvent<HTMLSelectElement>) => {
        table.setPageSize(Number(event.target.value));
        setCurrentPageSize(event.target.value);
    };

    return (
        <Flex {...paginationContainerStyle}>
            <Flex alignItems="center">
                <Text color="gray.700" fontSize="sm" flexShrink="0" mr="8px">
                    {translate('table.footer.page_number')}
                </Text>
                <Select value={pageSize || currentPageSize} size="sm" minW="75px" onChange={handleChangeSelect}>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                </Select>
            </Flex>
            <Flex alignItems="center">
                <Text color="gray.700" fontSize="sm" mr="8px">{`page ${table.getState().pagination.pageIndex + 1} of ${table.getPageCount()}`}</Text>
                <Flex>
                    <IconButton
                        onClick={() => table.previousPage()}
                        disabled={!table.getCanPreviousPage()}
                        aria-label="back pagination"
                        variant="unstyled"
                        icon={<ChevronLeftIcon />}
                    />
                    <IconButton
                        onClick={() => table.nextPage()}
                        disabled={!table.getCanNextPage()}
                        aria-label="next pagination"
                        variant="unstyled"
                        icon={<ChevronRightIcon />}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};

export default TablePagination;
